/** Customer-facing second screen, kept in step with the cashier's bill over BroadcastChannel (same browser, no server). */
export const DISPLAY_CHANNEL = "tos-customer-display";

export type DisplayMessage =
  | { type: "cart"; templeName: string; lines: { name: string; qty: number; amount: number }[]; total: number; upi: { link: string; amount: number } | null }
  | { type: "paid"; templeName: string; total: number; change: number | null; number: string | null }
  | { type: "idle"; templeName: string };

let channel: BroadcastChannel | null = null;
let last: DisplayMessage["type"] | null = null;

/** The display goes back to its welcome screen by itself after the thank-you, so "idle" never cuts that short. */
export function postDisplay(msg: DisplayMessage): void {
  if (typeof BroadcastChannel === "undefined") return;
  if (msg.type === "idle" && last !== "cart") return;
  last = msg.type;
  channel ??= new BroadcastChannel(DISPLAY_CHANNEL);
  channel.postMessage(msg);
}

export function openCustomerDisplay(): void {
  window.open("/customer-display", "tos-customer-display", "popup,width=1024,height=768");
}
